import { getTimeframeIndexedPath } from '../timeframes/timeframes-form.utils';

export const getIndicatorsPath = (timeframeIndex: number) => {
  return `${getTimeframeIndexedPath(timeframeIndex)}.indicators` as const;
};

export const getIndicatorIndexedPath = (
  indicatorsPath: IndicatorsPath,
  indicatorIndex: number
) => {
  return `${indicatorsPath}.${indicatorIndex}` as const;
};

export type IndicatorsPath = ReturnType<typeof getIndicatorsPath>;
export type IndicatorIndexedPath = ReturnType<typeof getIndicatorIndexedPath>;
